import { ValuesByComparingDimension } from '../barChart.types';

export const getBarCountInfo = (
	valuesByComparingDimension: ValuesByComparingDimension = [],
) => {
	const barPerGroupCount = valuesByComparingDimension.length;
	const barCounts = valuesByComparingDimension.map(
		({ dataList }) => dataList.length,
	);
	const barGroupCount = Math.max(...barCounts);

	return {
		barPerGroupCount,
		barGroupCount,
		totalBarCount: barPerGroupCount * barGroupCount,
	};
};

export const getAllAxisLabels = (
	valuesByComparingDimension: ValuesByComparingDimension,
) => {
	const dataList = valuesByComparingDimension[0].dataList;

	if (!dataList) return [];

	return dataList.reduce((allAxisLabels, { axisLabel }) => {
		return allAxisLabels.concat(axisLabel.split('\n'));
	}, [] as Array<string>);
};

export const getAllLegendLabels = (
	valuesByComparingDimension: ValuesByComparingDimension,
) => {
	return valuesByComparingDimension.reduce(
		(allLegendLabels, { legendLabel }) => {
			return legendLabel
				? allLegendLabels.concat(legendLabel.split('\n'))
				: allLegendLabels;
		},
		[] as Array<string>,
	);
};
